'use client';

import Script from 'next/script';

import { isProduction } from '@/helpers/common';

export const HotjarPromoScript = () => {
  if (!isProduction()) {
    return null;
  }

  return <Script strategy="afterInteractive" src="/pixels/hotjar-promo.js" />;
};
